import React, { useEffect, useState } from "react";
import { VscCircleSmallFilled } from "react-icons/vsc";

const ObjectLoader: React.FC = () => {
  const [loadDot, setLoadDot] = useState<number>(0);

  useEffect(() => {
    const intervalLD = setInterval(() => {
      setLoadDot((prevDot) => (prevDot + 1) % 8);
    }, 300);
    return () => clearInterval(intervalLD);
  }, []);

  const dotRotations = [
    "rotate-0",
    "rotate-45",
    "rotate-90",
    "rotate-[135deg]",
    "rotate-180",
    "rotate-[225deg]",
    "rotate-[270deg]",
    "rotate-[315deg]",
  ];

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-12 h-12 flex items-center justify-center animate-spin relative">
        {dotRotations.map((rotation, index) =>
          loadDot >= index ? (
            <div key={index} className={`absolute w-12 h-12 ${rotation}`}>
              <VscCircleSmallFilled className="text-black" />
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default ObjectLoader;
